import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";

export default {
  namespaced: true,
  state: {
    projectsList: [],
    projectThumnails:[]
  },
  getters: {
    PROJECTS_LIST(state) {
      return state.projectsList;
    },
    PROJECTS_THUMBNAILS_LIST(state) {
      return state.projectThumnails;
    },
  },
  mutations: {
    UPDATE_PROJECTS_LIST(state, payload) {
      state.projectsList.push(payload);
    },
    UPDATE_PROJECTS_THUMBNAILS_LIST(state, payload) {
      state.projectThumnails.push(payload);
    },
  },
  actions: {
    GET_PROJECTS({ commit, getters }) {
      if (getters.PROJECTS_LIST.length == 0) {
        firebase
          .firestore()
          .collection("projects")
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              commit("UPDATE_PROJECTS_LIST", { id: doc.id, ...doc.data() });
            });
          });
      }
    },
    GET_PROJECTS_THUMBNAILS({ commit, getters }) {
      if (getters.PROJECTS_THUMBNAILS_LIST.length == 0) {
        firebase
          .storage()
          .ref('Project thumbnails/')
          .listAll()
          .then(results => {
            if (results.items.length == 0) {
              commit("UPDATE_PROJECTS_THUMBNAILS_LIST", '/missing_image.webp');
            } else {
              results.items.forEach(async function(item) {
                 const imagePath = await item.getDownloadURL()
                 commit("UPDATE_PROJECTS_THUMBNAILS_LIST", imagePath);
              });
            }
          }).catch(err => {
            console.log(err);
            commit("UPDATE_PROJECTS_THUMBNAILS_LIST", '/missing_image.webp');
          })
      }
    },
  },
};
